import { COLORS } from "../../../constants";

const initialState = { listPerusahaan: { content: [] } };

export default function perusahaanReducer(state = initialState, action) {
  switch (action.type) {
    case "POST_DATA_API":
      return action.data;
    case "GET_DATA_PERUSAHAAN":
      const companies = action.data.content.map((c, i) => {
        const colors = {
          "00ed7c5c-b0db-4ec3-8639-551603409a79": "#43A047", // PT Agro Jabar
          "c3d07e15-9dcc-4040-b351-bdd1f453589a": "#C36839", // PT Agronesia
          "8085cf6b-aabd-47b5-913b-2b17badb1e7a": "#00A19D", // PT BIJB
          "c97eb793-f20c-4531-9f48-a7f0a82929b3": "#FDD835", // PT Jamkrida
          "32097ed8-a2cf-4005-ae40-abecbe7f1905": "#5C7AEA", // PT Jasa Sarana
          "6ce17135-34b5-4649-b2cb-648984c71ab4": "#8E44AD", // PT Jaswita
          "1083ade1-980a-4ed0-b99b-3505bf08bee1": "#FF5733", // PT Migas Hulu
          "77b8bea9-310e-4a56-93b9-0d5e386d2761": "#455A64", // PT Tirta Gemah Ripah
          "456cba84-20f0-4f80-91c9-29d33b5d436e": "#FF8DAD", // PDAP
        };
        if (colors.hasOwnProperty(c.id)) c.color = colors[c.id];
        else c.color = COLORS[i % COLORS.length];
        return c;
      });
      action.data.content = companies;
      return {
        ...state,
        listPerusahaan: action.data,
        totalPages: action.data.totalPages,
      };
    case "GET_DATA_TABLE_PERUSAHAAN":
      return {
        ...state,
        dataTablePerusahaan: action.data,
      };
    default:
      return state;
  }
}
